import { useCallback, useEffect, useState } from 'react';

import { storage } from '../storage';

export function useOnceValue(key: string, auto = true) {
  const [enable, setEnable] = useState(false);
  useEffect(() => {
    try {
      setEnable(storage.once.getItem(key) === null);
      if (auto) storage.once.setItem(key, 'true');
    } catch {
      //
    }
  }, [auto, key]);

  const trigger = useCallback(() => {
    if (!storage.once.getItem(key)) storage.once.setItem(key, 'true');
  }, [key]);

  const close = useCallback(() => setEnable(false), []);

  return { enable, trigger, close };
}
